import React, { useEffect, useMemo, useRef, useState } from "react";
import "./JMWhatsAppAssistant.css";

/* ============================================================
   Small inline icon components (converted from the raw <svg>
   markup in the original HTML — attributes are camelCased for
   JSX, e.g. stroke-width -> strokeWidth).
   ============================================================ */

const WhatsAppGlyph = (props) => (
  <svg viewBox="0 0 24 24" {...props}>
    <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2 22l5.25-1.38a9.87 9.87 0 0 0 4.79 1.22h.01c5.46 0 9.91-4.45 9.91-9.91C21.96 6.45 17.5 2 12.04 2Zm5.8 14.02c-.24.68-1.42 1.31-1.96 1.35-.5.04-.98.22-3.32-.7-2.8-1.1-4.56-3.98-4.7-4.17-.14-.19-1.12-1.49-1.12-2.84s.71-2.01.96-2.29c.25-.28.55-.35.73-.35s.37 0 .53.01c.17.01.4-.06.62.48.24.57.8 1.97.87 2.11.07.14.12.31.02.5-.1.19-.15.31-.29.47-.15.17-.31.37-.44.5-.15.14-.3.3-.13.59.17.28.76 1.25 1.63 2.03 1.12 1 2.06 1.31 2.35 1.45.29.15.46.12.63-.07.17-.19.73-.85.92-1.15.19-.29.38-.24.64-.14.26.09 1.66.78 1.94.93.29.14.48.21.55.33.07.12.07.69-.17 1.36Z" />
  </svg>
);

const WhatsAppButtonGlyph = (props) => (
  <svg viewBox="0 0 24 24" {...props}>
    <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2 22l5.25-1.38a9.87 9.87 0 0 0 4.79 1.22h.01c5.46 0 9.91-4.45 9.91-9.91C21.96 6.45 17.5 2 12.04 2Z" />
  </svg>
);

const JmLogoGlyph = (props) => (
  <svg viewBox="0 0 26 30" aria-hidden="true" {...props}>
    <path d="M22 0C12 6 5 16 2 30c6-3 9-8 11-14 1.6-5 4-11 9-16Z" fill="#E31B23" />
  </svg>
);

const ChevronLeft = (props) => (
  <svg viewBox="0 0 24 24" {...props}>
    <path d="M15.4 4.6 8 12l7.4 7.4 1.4-1.4L10.8 12l6-6z" />
  </svg>
);

const ChevronRight = (props) => (
  <svg viewBox="0 0 24 24" {...props}>
    <path d="M8.6 4.6 16 12l-7.4 7.4-1.4-1.4L13.2 12l-6-6z" />
  </svg>
);

/* stroke-based line icons used in pills + capability cards */
const IconPortfolioBars = ({ stroke }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke={stroke} strokeWidth="2">
    <path d="M4 20V10M10 20V4M16 20v-7M22 20H2" />
  </svg>
);
const IconTransact = ({ stroke }) => (
   <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    {/* Top rupee bar */}
    <path
      d="M6 6H17.5"
      stroke={stroke}
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    {/* Second rupee bar */}
    <path
      d="M6 9.2H16.2"
      stroke={stroke}
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    {/* Rupee curved/vertical structure */}
    <path
      d="M8 6C11.8 6 14.5 7.1 14.5 9.5C14.5 11.9 12.1 13 8 13H6.5"
      stroke={stroke}
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    {/* Diagonal leg */}
    <path
      d="M10 13L17 19"
      stroke={stroke}
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const IconDoc = ({ stroke }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke={stroke} strokeWidth="2">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8Z" />
    <path d="M14 2v6h6M8 13h8M8 17h5" />
  </svg>
);
const IconSearch = ({ stroke }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke={stroke} strokeWidth="2">
    <circle cx="11" cy="11" r="7" />
    <path d="m21 21-4.3-4.3" />
  </svg>
);
const IconGear = ({ stroke }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke={stroke} strokeWidth="2">
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.6 1.6 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.6 1.6 0 0 0-2.7 1.1 2 2 0 1 1-4 0 1.6 1.6 0 0 0-2.7-1.1l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1A1.6 1.6 0 0 0 3 15a2 2 0 1 1 0-4 1.6 1.6 0 0 0 1.1-2.7l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1A1.6 1.6 0 0 0 9.6 4.6a2 2 0 1 1 4 0 1.6 1.6 0 0 0 2.7 1.1l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1A1.6 1.6 0 0 0 21 11a2 2 0 1 1 0 4Z" />
  </svg>
);
const IconRefresh = ({ stroke }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke={stroke} strokeWidth="2">
    <path d="M21 12a9 9 0 1 1-3-6.7" />
    <path d="M21 3v5h-5" />
    <path d="M12 8v4l3 2" />
  </svg>
);
const IconSwitch = ({ stroke }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke={stroke} strokeWidth="2">
    <path d="M7 4 3 8l4 4" />
    <path d="M3 8h13a4 4 0 0 1 4 4" />
    <path d="m17 20 4-4-4-4" />
    <path d="M21 16H8a4 4 0 0 1-4-4" />
  </svg>
);
const IconCheckCircle = ({ stroke }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke={stroke} strokeWidth="2">
    <circle cx="12" cy="12" r="9" />
    <path d="m9 12 2 2 4-4" />
  </svg>
);
const IconPin = ({ stroke }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke={stroke} strokeWidth="2">
    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);

const NAVY = "#14306B";
const GREEN = "#0E7A3C";

/* ============================================================
   Data
   ============================================================ */

const PILLS_MOBILE = [
  { cls: "g", icon: <IconPortfolioBars stroke={GREEN} />, label: "View your portfolio" },
  { cls: "b", icon: <IconTransact stroke={NAVY} />, label: "Invest or transact" },
  { cls: "g", icon: <IconDoc stroke={GREEN} />, label: "Access statements" },
  { cls: "b", icon: <IconSearch stroke={NAVY} />, label: "Explore schemes information" },
  { cls: "g", icon: <IconGear stroke={GREEN} />, label: "Track Transaction requests" },
];

const PILLS_DESKTOP = [
  { cls: "g", pos: "p1", icon: <IconPortfolioBars stroke={GREEN} />, label: "View your portfolio" },
  { cls: "b", pos: "p2", icon: <IconTransact stroke={NAVY} />, label: "Invest or transact" },
  { cls: "g", pos: "p3", icon: <IconDoc stroke={GREEN} />, label: "Access statements" },
  { cls: "b", pos: "p4", icon: <IconSearch stroke={NAVY} />, label: "Explore scheme information" },
  { cls: "g", pos: "p5", icon: <IconGear stroke={GREEN} />, label: "Track Transaction requests" },
];

const STEPS = [
  { n: "STEP 1", title: "Save the number", body: "Add +91 89767 85799 to your contacts." },
  { n: "STEP 2", title: 'Send "Hi"', body: "The welcome menu comes back instantly." },
  { n: "STEP 3", title: "Pick an option", body: "Everything runs on menu choices." },
  { n: "STEP 4", title: "Verify with PAN", body: "An OTP goes to your registered mobile and email." },
];

const CAPABILITIES = [
  {
    icon: <IconTransact stroke={GREEN} />,
    title: "Purchase",
    desc: "Buy into an equity, debt or cash scheme. Choose your folio, enter the amount and distributor details, then pay by UPI or net banking. A transaction ID follows on confirmation.",
    tags: [{ t: "PAN + OTP", a: true }, { t: "2FA at payment" }, { t: "UPI / Net banking" }],
  },
  {
    icon: <IconRefresh stroke={GREEN} />,
    title: "SIP",
    desc: "Register a new SIP — daily, weekly, monthly, half-yearly or annual. Set the amount, start date and number of instalments, and choose whether to pay the first instalment now.",
    tags: [{ t: "PAN + OTP", a: true }, { t: "Mandate or first instalment" }],
  },
  {
    icon: <IconSwitch stroke={GREEN} />,
    title: "Switch",
    desc: "Move money between schemes in the same folio. Switch all units, part of your units, or a specific amount, after reviewing units available and current value.",
    tags: [{ t: "PAN + OTP", a: true }],
  },
  {
    icon: <IconDoc stroke={GREEN} />,
    title: "Statements",
    desc: "Request an account statement by PAN or folio, or a capital gains statement. Pick the period you need — the file is emailed to your registered email ID.",
    tags: [{ t: "PAN + OTP", a: true }, { t: "Sent to registered email" }],
  },
  {
    icon: <IconPortfolioBars stroke={GREEN} />,
    title: "Portfolio Valuation",
    desc: "See your current holdings and value, either across every folio linked to your PAN or for one folio at a time.",
    tags: [{ t: "PAN + OTP", a: true }],
  },
  {
    icon: <IconCheckCircle stroke={GREEN} />,
    title: "Transaction Status",
    desc: "Check your last ten transactions against your PAN, or look up one specific transaction using the transaction ID from its confirmation message.",
    tags: [{ t: "PAN + OTP", a: true }],
  },
  {
    icon: <IconPin stroke={GREEN} />,
    title: "Branch Locator",
    desc: "Find our branches or KFintech service centres near you by entering a city or PIN code. Matching branch details come back in the chat.",
    tags: [{ t: "No verification needed" }],
  },
  {
    icon: <IconSearch stroke={GREEN} />,
    title: "Explore Funds",
    desc: "Look up the latest NAV, browse equity, debt and cash schemes, or get direct links to application forms, transactional forms and KYC status.",
    tags: [{ t: "No verification needed" }],
  },
  {
    icon: <IconGear stroke={GREEN} />,
    title: "NCT Services",
    desc: "Update contact details, bank account or nominee, or register a mandate. The assistant hands you to the KFintech investor portal to complete these.",
    tags: [{ t: "Completed on KFintech" }],
  },
];

const FAQ_TABS = [
  { cat: "start", label: "Getting started" },
  { cat: "auth", label: "PAN & OTP" },
  { cat: "txn", label: "Transacting" },
  { cat: "info", label: "Statements & portfolio" },
  { cat: "service", label: "Account services" },
  { cat: "trouble", label: "When something fails" },
];

const FAQ_ITEMS = [
  { cat: "start", q: "How do I start using the WhatsApp assistant?", a: (
    <p>Save <strong>+91 89767 85799</strong> to your contacts as JM Financial Mutual Fund, open WhatsApp and send <strong>Hi</strong>. The welcome menu arrives immediately and you choose from there.</p>
  )},
  { cat: "start", q: "Do I need to register or download anything first?", a: (
    <p>No. If you have WhatsApp and a PAN linked to a JM Financial Mutual Fund folio, you are ready. There is no separate app, login or password — your PAN and a one-time password do the verification.</p>
  )},
  { cat: "start", q: "Can I use it if I have never invested with JM Financial Mutual Fund?", a: (
    <p>Partly. Open options such as NAV lookup, scheme information, forms, downloads and branch locator work for everyone. Transactions, statements and portfolio views need a PAN with an existing folio, so if you are new to the fund the assistant will tell you no folio was found against your PAN.</p>
  )},
  { cat: "start", q: "Which number is the official one?", a: (
    <p>Only <strong>+91 89767 85799</strong>. It is a verified WhatsApp Business account showing the name JM Financial Mutual Fund. Treat any other number claiming to be our assistant as unverified.</p>
  )},
  { cat: "start", q: "Can my distributor's details be captured on a transaction?", a: (
    <p>Yes. During a purchase, SIP or switch you can enter the <strong>ARN number</strong>, <strong>EUIN</strong> (or record the EUIN declaration), <strong>sub-broker ARN</strong> and <strong>sub-broker</strong> code. Leave these blank if you are transacting on your own.</p>
  )},

  { cat: "auth", q: "Why does it ask for my PAN?", a: (
    <p>Your PAN is how the assistant finds the folios that belong to you. It is the first level of verification for anything that touches your money or your data — purchases, SIPs, switches, statements, portfolio and transaction status.</p>
  )},
  { cat: "auth", q: "Where is the OTP sent?", a: (
    <p>To the email ID and mobile number registered against your last transacted folio. If those details are out of date, update them first through <strong>NCT Services</strong> on the menu.</p>
  )},
  { cat: "auth", q: "Why am I asked for a second OTP before a transaction goes through?", a: (
    <p>That is two-factor authentication. The first OTP confirms it is your PAN; the second confirms the specific transaction you just reviewed. Only after the second OTP is the payment link and transaction ID generated.</p>
  )},
  { cat: "auth", q: "Should I ever share the OTP with anyone?", a: (
    <p>Never — not with a distributor, not with anyone claiming to be from JM Financial Mutual Fund, and not with anyone offering to complete a transaction for you. We will never ask you for an OTP over a call, an email or a separate chat.</p>
  )},

  { cat: "txn", q: "How do I make a one-time investment?", a: (
    <>
      <p>Choose <strong>Purchase</strong>, verify your PAN with the OTP, then tap Start Purchase. Pick a scheme category (equity, debt or cash), choose the scheme and folio, enter the amount and any distributor details, and accept the terms and conditions.</p>
      <p>Pay by UPI or net banking using a bank mapped to your folio. Once payment succeeds you get a confirmation message with your transaction ID.</p>
    </>
  )},
  { cat: "txn", q: "Which payment methods are supported?", a: (
    <>
      <p><strong>UPI</strong> and <strong>net banking</strong>. You choose your bank from the list already mapped to your folio. For SIPs you can also pay through a registered mandate.</p>
      <p className="note">The NAV you receive depends on when the funds are realised. Review the NAV applicability matrix before you pay.</p>
    </>
  )},
  { cat: "txn", q: "What SIP frequencies and dates can I choose?", a: (
    <p>Daily, weekly, monthly, half-yearly or annual. The nearest eligible start date is filled in for you, and you can change it to any date from the <strong>1st to the 28th</strong>. You also set the SIP amount and the number of instalments.</p>
  )},
  { cat: "txn", q: "Do I have to pay the first SIP instalment immediately?", a: (
    <p>No, it is your choice. Say yes and a payment link is generated along with a transaction ID, which you complete by UPI or net banking. Say no and the SIP is simply registered, with future instalments collected through your mandate.</p>
  )},
  { cat: "txn", q: "How do I use an existing mandate for my SIP?", a: (
    <p>At the payment step, choose <strong>Select Mandate</strong>. The assistant shows the mandates linked to your bank account with the bank name, account number, UMRN and maximum cap amount, so you can confirm the right one before continuing.</p>
  )},
  { cat: "txn", q: "How does a switch work?", a: (
    <>
      <p>Pick <strong>Switch</strong>, verify your PAN, then choose the folio and the scheme you are switching out of — the assistant shows the units available and their current value. Select the target scheme and the switch method:</p>
      <ul>
        <li><strong>All units</strong> — move the entire holding</li>
        <li><strong>Partial units</strong> — enter the number of units</li>
        <li><strong>Partial amount</strong> — enter a rupee value</li>
      </ul>
      <p>Review the summary and confirm. A transaction ID follows.</p>
    </>
  )},

  { cat: "info", q: "How do I get an account statement?", a: (
    <>
      <p>Choose <strong>Statements</strong>, then <strong>Account Statement</strong>, then whether you want it across your whole PAN or for a single folio. After OTP verification, pick a period: current financial year, previous financial year, a custom date range, since inception, last one year, last three months or last month.</p>
      <p>The assistant confirms on WhatsApp and the statement is emailed to your registered email ID.</p>
    </>
  )},
  { cat: "info", q: "Can I get a capital gains statement?", a: (
    <p>Yes. Choose <strong>Statements</strong> and then <strong>Capital Gain Statement</strong>. Periods available are current financial year, previous financial year or a custom date range. It is emailed to your registered email ID.</p>
  )},
  { cat: "info", q: "Why is my statement emailed instead of sent on WhatsApp?", a: (
    <p>Statements contain your full account detail, so they go to the email ID registered on your folio rather than to a chat thread. WhatsApp gets the confirmation that the statement is on its way.</p>
  )},
  { cat: "info", q: "How do I see my current portfolio value?", a: (
    <p>Choose <strong>Portfolio Valuation</strong> and then PAN or folio. A PAN view shows your holdings across every folio linked to that PAN; a folio view lets you pick one folio from the list and see it on its own.</p>
  )},
  { cat: "info", q: "How do I check whether a transaction went through?", a: (
    <p>Choose <strong>Transaction Status</strong>. Searching by PAN returns your last ten transactions with their status. If you have the transaction ID from a confirmation message, search by that instead to see just that one.</p>
  )},
  { cat: "info", q: "Can I check NAVs or read about a scheme without verifying?", a: (
    <p>Yes. <strong>Explore Funds</strong> gives you fund NAVs, scheme information across equity, debt and cash, and a downloads section with application forms, transactional and non-transactional forms, and KYC status — none of which need your PAN.</p>
  )},

  { cat: "service", q: "Can I update my mobile number, email, bank or nominee?", a: (
    <p>Yes, through <strong>NCT Services</strong> on the menu — update contact details, update bank account, update nominee or register a mandate. These are completed on the KFintech investor portal, and the assistant sends you the link to get there.</p>
  )},
  { cat: "service", q: "How do I find a branch near me?", a: (
    <p>Choose <strong>Branch Locator</strong>, then either our own branches or KFintech branches, and enter your city or PIN code. Matching branch details come back in the chat.</p>
  )},
  { cat: "service", q: "Where do I check my KYC status?", a: (
    <p>Under <strong>Explore Funds → Downloads</strong>, alongside the links to investment, application, transactional and non-transactional forms.</p>
  )},

  { cat: "trouble", q: "It says my PAN is not KYC compliant. What now?", a: (
    <p>Transactions cannot proceed until your KYC is complete. Check your status through <strong>Explore Funds → Downloads → KYC status</strong>, complete the KYC formalities, and come back to the assistant afterwards.</p>
  )},
  { cat: "trouble", q: "It says my PAN is incorrect or no folio was found.", a: (
    <p>Re-enter the PAN carefully — ten characters, no spaces. If it is correct and you still see the message, there is probably no folio against that PAN with us yet. Your distributor or our investor services team can confirm.</p>
  )},
  { cat: "trouble", q: "My OTP is wrong, or I have used up my attempts.", a: (
    <p>Check that you are reading the most recent OTP, as an earlier one will no longer work. After too many wrong attempts the session closes for your safety — send <strong>Hi</strong> again to start over. If the OTP is not reaching you at all, your registered mobile or email may be out of date.</p>
  )},
  { cat: "trouble", q: "It says the amount is below the minimum.", a: (
    <p>Each scheme has its own minimum for a fresh purchase, an additional purchase and an SIP instalment. Enter an amount at or above the minimum shown in the message, or pick a different scheme.</p>
  )},
  { cat: "trouble", q: "My switch was rejected for units or balance.", a: (
    <p>Three things commonly cause this: the folio has no investment in the scheme you selected, the minimum balance rule would be breached by the switch, or the units or amount you entered are below the scheme minimum. Switching all units avoids the last two.</p>
  )},
  { cat: "trouble", q: "It says EUIN or the EUIN declaration is mandatory.", a: (
    <p>When an ARN is entered, you must either provide the EUIN of the person who advised you or record the declaration that the transaction was executed without advice. One of the two is required before the transaction can continue.</p>
  )},
  { cat: "trouble", q: "It says the agent code or RIA code is invalid.", a: (
    <p>The ARN, sub-broker ARN or RIA code entered does not match a registered code. Confirm the exact code with your distributor or adviser and enter it again, or leave the field blank to transact directly.</p>
  )},
  { cat: "trouble", q: "My payment failed but the money left my account.", a: (
    <p>Check <strong>Transaction Status</strong> with your transaction ID first — the confirmation sometimes lands after the bank page closes. If the status is still unsuccessful, failed payments are reversed by your bank, and our investor services team can trace the transaction ID for you.</p>
  )},
];

const SAFETY = [
  { title: "One number only", body: "+91 89767 85799, shown as a verified business account under the name JM Financial Mutual Fund. Nothing else is ours." },
  { title: "OTPs stay with you", body: "We never ask for an OTP on a call, an email, or any chat other than this one. Nobody needs it to help you." },
  { title: "Money moves only through your bank", body: "Payments happen on your own bank or UPI screen, into schemes held against your PAN. The assistant never asks for card or account numbers." },
];

const WA_LINK = "https://wa.me/918976785799?text=Hi";

/* ============================================================
   Component
   ============================================================ */

export default function JMWhatsAppAssistant() {
  /* ---------- carousel ---------- */
  const trackRef = useRef(null);
  const cardRefs = useRef([]);
  const [cardIndex, setCardIndex] = useState(0);
  const [perView, setPerView] = useState(1);
  const [maxIndex, setMaxIndex] = useState(CAPABILITIES.length - 1);

  const step = () => {
    const first = cardRefs.current[0];
    if (!first) return 0;
    return first.getBoundingClientRect().width + 18;
  };

  const syncCarousel = () => {
    const track = trackRef.current;
    if (!track) return;
    const s = step();
    if (!s) return;
    const per = Math.max(1, Math.round(track.clientWidth / s));
    const mIdx = Math.max(0, CAPABILITIES.length - per);
    const cur = Math.min(mIdx, Math.round(track.scrollLeft / s));
    setPerView(per);
    setMaxIndex(mIdx);
    setCardIndex(cur);
  };

  const goToCard = (i) => {
    const clamped = Math.max(0, Math.min(CAPABILITIES.length - 1, i));
    const track = trackRef.current;
    if (track) track.scrollTo({ left: clamped * step(), behavior: "smooth" });
  };

  useEffect(() => {
    syncCarousel();
    const track = trackRef.current;
    let t;
    const onScroll = () => {
      clearTimeout(t);
      t = setTimeout(syncCarousel, 90);
    };
    const onResize = () => syncCarousel();
    if (track) track.addEventListener("scroll", onScroll);
    window.addEventListener("resize", onResize);
    return () => {
      if (track) track.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onResize);
      clearTimeout(t);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onTrackKeyDown = (e) => {
    if (e.key === "ArrowRight") {
      e.preventDefault();
      goToCard(cardIndex + 1);
    }
    if (e.key === "ArrowLeft") {
      e.preventDefault();
      goToCard(cardIndex - 1);
    }
  };

  const counterLabel = `${cardIndex + 1} – ${Math.min(
    CAPABILITIES.length,
    cardIndex + perView
  )} / ${CAPABILITIES.length}`;

  /* ---------- FAQ ---------- */
  const [category, setCategory] = useState("start");
  const [search, setSearch] = useState("");
  const [openMap, setOpenMap] = useState({});

  const term = search.trim().toLowerCase();

  const visibleItems = useMemo(() => {
    return FAQ_ITEMS.map((item, i) => {
      const haystack = (item.q + " " + (item.aText || "")).toLowerCase();
      const matches = term ? haystack.indexOf(term) !== -1 : item.cat === category;
      return { ...item, _i: i, _visible: matches };
    });
  }, [term, category]);

  // Auto-open matches while searching, collapse otherwise-hidden ones.
  useEffect(() => {
    setOpenMap((prev) => {
      const next = { ...prev };
      visibleItems.forEach((item) => {
        if (term && item._visible) next[item._i] = true;
        if (!item._visible) next[item._i] = false;
      });
      return next;
    });
  }, [term, category, visibleItems]);

  const shownCount = visibleItems.filter((i) => i._visible).length;

  const handleTabClick = (cat) => {
    setCategory(cat);
    setSearch("");
  };

  const toggleDetail = (i) => {
    setOpenMap((prev) => ({ ...prev, [i]: !prev[i] }));
  };

  return (
    <div className="jmwa">
      {/* ================= SCROLL 1 : BANNER ================= */}
      <div className="banner">
        <div className="swoosh" aria-hidden="true">
          <svg viewBox="0 0 1440 900" preserveAspectRatio="xMidYMid slice">
            <path d="M1180 -60 C1340 120 1420 340 1440 560 L1440 -60Z" fill="#E8F5EC" opacity=".7" />
            <path d="M1240 -60 C1380 160 1440 400 1440 620 L1440 -60Z" fill="#E7EFFA" opacity=".55" />
            <path d="M-40 900 C120 760 180 600 160 420 L-40 420Z" fill="#E8F5EC" opacity=".55" />
            <path d="M0 960 C220 820 300 620 280 400 L0 400Z" fill="#E7EFFA" opacity=".4" />
          </svg>
        </div>

        <div className="topbar">
          <div className="wrap">
            <div className="logo">
              <JmLogoGlyph />
              <div className="txt">
                <div className="n1">JM Financial</div>
                <div className="n2">MUTUAL FUND</div>
              </div>
            </div>
            <div className="num">
              WhatsApp us on &nbsp;<b>+91 89767 85799</b>
            </div>
          </div>
        </div>

        <div className="banner-body">
          <div className="wrap banner-grid">
            <div>
              <h1>
                <span className="l1">One chat.</span>
                <span className="l2">Many mutual fund needs.</span>
              </h1>
              <p className="sub">JM Financial Mutual Fund is now on WhatsApp.</p>

              <div className="numpill">
                <span className="waicon">
                  <WhatsAppGlyph fill="#fff" />
                </span>
                <span>
                  <span className="lbl">WHATSAPP US ON</span>
                  <span className="val">+91 89767 85799</span>
                </span>
              </div>

              <div className="acts">
                <a className="btn btn-p" href={WA_LINK}>
                  <WhatsAppButtonGlyph />
                  Say Hi on WhatsApp
                </a>
                <a className="btn btn-s" href="#help">
                  See what it can do
                </a>
              </div>

              <div className="pills-m">
                {PILLS_MOBILE.map((p, i) => (
                  <span className={`pill ${p.cls}`} key={i}>
                    <i>{p.icon}</i>
                    {p.label}
                  </span>
                ))}
              </div>
            </div>

            <div className="stage">
              {PILLS_DESKTOP.map((p, i) => (
                <span className={`pill ${p.cls} ${p.pos}`} key={i}>
                  <i>{p.icon}</i>
                  {p.label}
                </span>
              ))}

              <div
                className="phone"
                role="img"
                aria-label="WhatsApp chat with JM Financial Mutual Fund showing the welcome message."
              >
                <div className="ph-top">
                  <span className="ph-av">
                    <JmLogoGlyph />
                  </span>
                  <span>
                    <span className="ph-nm">
                      JM Financial Mutual Fund <em>✔</em>
                    </span>
                    <span className="ph-st">Online</span>
                  </span>
                </div>
                <div className="thread">
                  <div className="bub">
                    <b>Hi! 👋</b>
                    Welcome to JM Financial Mutual Fund on WhatsApp!
                    <br />
                    <br />
                    How can we help you today?
                    <span className="tm">9:41 AM</span>
                  </div>
                </div>
                <div className="ph-in">
                  <span>Type a message…</span>
                  <i></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ================= SCROLL 2 : CAPABILITIES ================= */}
      <section id="help">
        <div className="wrap">
          <div className="strip">
            {STEPS.map((s, i) => (
              <div key={i}>
                <div className="n">{s.n}</div>
                <h3>{s.title}</h3>
                <p>{s.body}</p>
              </div>
            ))}
          </div>

          <div className="sechead">
            <div>
              <h2>What the assistant can do</h2>
              <p>
                Nine options on the main menu. Those marked PAN + OTP need verification; the rest
                are open to everyone.
              </p>
            </div>
          </div>

          <div className="carousel">
            <div
              className="track"
              id="track"
              tabIndex={0}
              role="region"
              aria-label="Assistant capabilities, scrollable"
              ref={trackRef}
              onKeyDown={onTrackKeyDown}
            >
              {CAPABILITIES.map((c, i) => (
                <article
                  className="card"
                  key={i}
                  ref={(el) => (cardRefs.current[i] = el)}
                >
                  <span className="ic">{c.icon}</span>
                  <h3>{c.title}</h3>
                  <p>{c.desc}</p>
                  <div className="tags">
                    {c.tags.map((t, ti) => (
                      <span className={`tag ${t.a ? "a" : ""}`} key={ti}>
                        {t.t}
                      </span>
                    ))}
                  </div>
                </article>
              ))}
            </div>

            <div className="cnav">
              <button
                className="arrow"
                aria-label="Previous capabilities"
                onClick={() => goToCard(cardIndex - 1)}
                disabled={cardIndex <= 0}
              >
                <ChevronLeft />
              </button>
              <button
                className="arrow"
                aria-label="Next capabilities"
                onClick={() => goToCard(cardIndex + 1)}
                disabled={cardIndex >= maxIndex}
              >
                <ChevronRight />
              </button>
              <div className="dots" role="tablist" aria-label="Go to capability">
                {CAPABILITIES.map((c, i) => (
                  <button
                    key={i}
                    type="button"
                    className="dot"
                    aria-current={i === cardIndex}
                    aria-label={`Go to ${c.title}`}
                    onClick={() => goToCard(i)}
                  />
                ))}
              </div>
              <span className="of">{counterLabel}</span>
            </div>
          </div>
        </div>
      </section>

      {/* ================= SCROLL 3 : FAQ ================= */}
      <section className="faq" id="faq">
        <div className="wrap">
          <div className="sechead">
            <div>
              <h2>Frequently asked questions</h2>
              <p>Pick a stage of the journey, or search across all thirty questions.</p>
            </div>
          </div>

          <div className="tools">
            <input
              id="q"
              type="search"
              placeholder='Search — try "OTP", "SIP date", "statement"'
              aria-label="Search frequently asked questions"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>

          <div className="tabs" role="tablist" aria-label="FAQ categories">
            {FAQ_TABS.map((t) => (
              <button
                key={t.cat}
                className="tab"
                role="tab"
                aria-selected={category === t.cat}
                style={{ opacity: term ? 0.45 : 1 }}
                onClick={() => handleTabClick(t.cat)}
              >
                {t.label}
              </button>
            ))}
          </div>

          <p className={`empty ${shownCount ? "" : "show"}`} id="empty">
            No questions match that search. Try a different word, or message the assistant
            directly.
          </p>

          <div className="qcols" id="qcols">
            {visibleItems.map((item) =>
              item._visible ? (
                <details
                  key={item._i}
                  data-cat={item.cat}
                  open={!!openMap[item._i]}
                  onToggle={(e) => {
                    const isOpen = e.currentTarget.open;
                    setOpenMap((prev) =>
                      prev[item._i] === isOpen ? prev : { ...prev, [item._i]: isOpen }
                    );
                  }}
                >
                  <summary onClick={(e) => { e.preventDefault(); toggleDetail(item._i); }}>
                    {item.q}
                  </summary>
                  <div className="ans">{item.a}</div>
                </details>
              ) : null
            )}
          </div>
        </div>
      </section>

      <div className="tail">
        <div className="wrap">
          <h2>Staying safe on chat</h2>
          <div className="safe">
            {SAFETY.map((s, i) => (
              <div key={i}>
                <h3>{s.title}</h3>
                <p>{s.body}</p>
              </div>
            ))}
          </div>
          <div className="finalcta">
            <div>
              <strong style={{color: "#fff"}}>Send "Hi" and see for yourself</strong>
              <span>Nothing is committed until you review a summary and confirm it with an OTP.</span>
            </div>
            <a className="btn btn-w btn-below" href={WA_LINK} style={{fill: "#07562A"}}>
              <WhatsAppButtonGlyph />
              Chat with the assistant
            </a>
          </div>
        </div>
      </div>

      <footer>
        <div className="wrap">
          <p className="reg">
            SEBI Registered Name: JM Financial Mutual Fund &nbsp;·&nbsp; Registration No.: MF/015/94/8
          </p>
          <p className="risk">
            Mutual Fund investments are subject to market risks, read all scheme related documents
            carefully.
          </p>
          <p>
            Features described on this page are provided by the JM Financial Mutual Fund WhatsApp
            business assistant and may be modified at any time. Message and data rates from your
            mobile operator may apply. Statements and reports are sent to the email ID registered
            against your folio. Non-commercial transaction requests are completed on the
            registrar's platform.
          </p>
        </div>
      </footer>
    </div>
  );
}